<div #calendaritem class="calendar-months-container" (window:resize)="onResize($event)">
    <div #calendarmonthitem *ngFor="let date of this.months; let index=index" class="calendarmonth-item"
        [ngStyle]="getStyleMonthItem()">
        <calendarmonth [monthWidth]="monthWidth" [monthHeight]="monthHeight" [readonly]="readonly" [calendar]="calendar"
            [initialdate]="getinitialdate(date)" [finaldate]="getfinaldate(date)" [monthCount]="monthCount"
            (onDateClick)="dayclick($event)" (onWeekDayClick)="weekdayclick({'value':$event, 'date':date})"
            (onWeekClick)="weekclick({'value':$event, 'date':date})" (onMonthClick)="monthclick(date)"
            [innerstyle]="getinnerstyle(date)"></calendarmonth>
    </div>
</div>